<template>
  <el-dropdown placement="bottom" @command="handleDropClick">
    <span class="click-cursor">{{ $t("common.Language") }}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        class="language-dropdown-item"
        :class="{ 'language-dropdown-item-no-open': !item.isOpen }"
        v-for="item in languages"
        :key="item.label"
        :disabled="!item.isOpen"
        :data-tooltip="item.isOpen ? '' : '即将开通'"
        :command="item"
      >
        {{ item.text }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, ref } from "vue";
import lang, { Language } from "./languages";
import { useStore } from "@whitekite/vue-helper";
import { Vue } from "vue/types/vue";

export default defineComponent({
  name: "LanguageDropdown",
  setup: (_props) => {
    const { proxy: root } = getCurrentInstance() as { proxy: Vue };
    const languages = ref<Language[]>(lang);

    const store = useStore<any>();

    const defineDropdownOrder = () => {
      const defaultLang = store.state.language;
      const index = languages.value.findIndex(
        (item) => item.label === defaultLang
      );
      if (index > 0) {
        // 将选的的语言置换到数组最前
        const [lang] = languages.value.splice(index, 1);
        languages.value.splice(0, 0, lang);
      }
    };

    const handleDropClick = (lang: Language) => {
      if (lang.isOpen) {
        store.commit("setLanguage", lang.label);
        root.$i18n.locale = lang.label;
        root.$router.go(0);
      }
    };

    defineDropdownOrder();

    return {
      languages,
      handleDropClick,
    };
  },
});
</script>

<style lang="scss">
.language-dropdown-item {
  text-align: center;
  padding: 5px 50px !important;
}
.language-dropdown-item:first-child {
  color: #21A2B2;
}
.language-dropdown-item-no-open {
  pointer-events: auto !important;
  position: relative;
}
.language-dropdown-item-no-open:hover:before {
  content: attr(data-tooltip);
  position: absolute;
  top: 73%;
  left: 20%;
  padding: 0 20px;
  text-align: center;
  background: #000000;
  font-size: 12px;
  color: #ffffff;
  line-height: 16px;
}
</style>
